import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { createPortal } from "react-dom";
import { Faded } from "baby-i-am-faded";
import clsx from "clsx";
import { useEffect } from "react";
Faded.defaultProps = {
    cascadeIncrement: 80,
    duration: 120
};
export function Modal(_param) {
    var tmp = _param.as, As = tmp === void 0 ? "div" : tmp, isOpen = _param.isOpen, onClose = _param.onClose, _className = _param.className, className = _className === void 0 ? "" : _className, content = _param.content, _disableAnimations = _param.disableAnimations, disableAnimations = _disableAnimations === void 0 ? false : _disableAnimations, _useDefaultContentStyle = _param.useDefaultContentStyle, useDefaultContentStyle = _useDefaultContentStyle === void 0 ? false : _useDefaultContentStyle, _initialFocus = _param.initialFocus, initialFocus = _initialFocus === void 0 ? null : _initialFocus, _maxWidth = _param.maxWidth, maxWidth = _maxWidth === void 0 ? "100%" : _maxWidth, _keepScrollBar = _param.keepScrollBar, keepScrollBar = _keepScrollBar === void 0 ? false : _keepScrollBar, _style = _param.style, style = _style === void 0 ? {} : _style, rest = _object_without_properties(_param, [
        "as",
        "isOpen",
        "onClose",
        "className",
        "content",
        "disableAnimations",
        "useDefaultContentStyle",
        "initialFocus",
        "maxWidth",
        "keepScrollBar",
        "style"
    ]);
    useEffect(function() {
        if (keepScrollBar) {
            return;
        }
        if (isOpen) {
            document.documentElement.style.overflow = "hidden";
        } else {
            document.documentElement.style.overflow = "";
        }
    }, [
        isOpen
    ]);
    useEffect(function() {
        var handler = function(event) {
            var ref;
            if ((event === null || event === void 0 ? void 0 : (ref = event.key) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === "escape") {
                event.preventDefault();
                onClose();
            }
        };
        document.addEventListener("keydown", handler);
        return function() {
            document.removeEventListener("keydown", handler);
        };
    }, []);
    var styles = _jsx(_JSXStyle, {
        id: "dd61b6f3c957de76",
        children: "@-webkit-keyframes zoomIn{from{opacity:0;-webkit-transform:scale(.9);transform:scale(.9)}to{opacity:1}}@-moz-keyframes zoomIn{from{opacity:0;-moz-transform:scale(.9);transform:scale(.9)}to{opacity:1}}@-o-keyframes zoomIn{from{opacity:0;-o-transform:scale(.9);transform:scale(.9)}to{opacity:1}}@keyframes zoomIn{from{opacity:0;-webkit-transform:scale(.9);-moz-transform:scale(.9);-o-transform:scale(.9);transform:scale(.9)}to{opacity:1}}@-webkit-keyframes simpleFade{from{opacity:0}to{opacity:1}}@-moz-keyframes simpleFade{from{opacity:0}to{opacity:1}}@-o-keyframes simpleFade{from{opacity:0}to{opacity:1}}@keyframes simpleFade{from{opacity:0}to{opacity:1}}"
    });
    if (!isOpen) {
        return styles;
    }
    return /*#__PURE__*/ createPortal(/*#__PURE__*/ _jsxs(As, _object_spread_props(_object_spread({
        className: "fixed inset-0 z-[1000] overflow-y-auto overflow-x-hidden"
    }, rest), {
        children: [
            styles,
            /*#__PURE__*/ _jsx(Faded, {
                disabled: disableAnimations,
                delay: 800,
                duration: 300,
                style: {
                    // transition:
                    //     'background 1s cubic-bezier(0.4, 0, 0.2, 1) !important',
                    backdropFilter: "blur(12px)",
                    // @ts-ignore
                    "-webkit-backdrop-filter": "blur(12px)",
                    background: "rgba(0, 0, 0, 0.1)"
                },
                onClick: function(e) {
                    onClose();
                    e.stopPropagation();
                },
                animationName: "simpleFade",
                className: "fixed inset-0 bg-black bg-opacity-20"
            }),
            /*#__PURE__*/ _jsx(Faded, {
                duration: 220,
                timingFunction: "ease-in-out-quad",
                disabled: disableAnimations,
                animationName: "zoomIn",
                style: _object_spread_props(_object_spread({}, style), {
                    maxWidth: "min(".concat(maxWidth, ", 100vw - 60px)")
                }),
                className: clsx("top-8 space-y-6 shadow-xl rounded-lg relative", "mx-auto min-w-0 isolate bg-transparent lg:top-14", className),
                children: useDefaultContentStyle ? /*#__PURE__*/ _jsx("div", {
                    className: clsx("w-auto text-gray-700 space-y-8 rounded-lg ring-gray-100", "ring-1 py-4 px-2 md:px-8 min-w-0 justify-center items-stretch", "flex-col flex bg-white dark:text-gray-100 dark:ring-gray-700", "dark:bg-gray-800"),
                    children: content
                }) : content
            })
        ]
    })), document.body);
}
export function CloseButton(_param) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, rest = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx("button", _object_spread_props(_object_spread({
        className: clsx("top-4 text-gray-600 shrink-0 rounded right-4", "p-1 bg-white/50 backdrop-blur appearance-none", "absolute dark:text-gray-400 dark:bg-gray-700/50", className),
        "aria-label": "Close",
        type: "button"
    }, rest), {
        children: /*#__PURE__*/ _jsx(RiCloseFill, {
            className: "h-7 w-7"
        })
    }));
}
function RiCloseFill(props) {
    return /*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            d: "m12 10.586l4.95-4.95l1.414 1.414l-4.95 4.95l4.95 4.95l-1.414 1.414l-4.95-4.95l-4.95 4.95l-1.414-1.414l4.95-4.95l-4.95-4.95L7.05 5.636z"
        })
    }));
}
Modal.CloseButton = CloseButton;
